export default __webpack_public_path__ + "static/media/selecao.9eb192ba.webp";